import { render, staticRenderFns } from "./RequiredSexe.vue?vue&type=template&id=666dfc34&scoped=true"
import script from "./RequiredSexe.vue?vue&type=script&lang=ts"
export * from "./RequiredSexe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666dfc34",
  null
  
)

export default component.exports